import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import LogsTable from './LogsTable';
import FullPageLoader from 'components/common/FullPageLoader';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import toast from 'react-hot-toast';
import { CheckinCheckoutAdjustmentModal } from 'components/appointment/checkinCheckoutAdjustment';
import CouldNotCover from 'components/appointment/CouldNotCover';
import DonotCover from 'components/appointment/DonotCover';
import CancelModal from 'components/appointment/CancelModal';
import { setActionAssign } from 'slices/actionButtonSlice';
import { fetchVendorAppointmentLogs } from 'slices/vendor/appointmentSlice';
import { fetchVendorAppointmentView } from 'slices/vendor/appointmentSlice';
import SelectInterpreterModal from 'components/vendorAccess/SelectInterpreterModal';
import ExtraMileage from 'components/appointment/ExtraMileage';
import ViewTable from 'views/appointment/view/ViewTable';

const AppointmentView = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [item, setItem] = React.useState({});
    const [loading, setLoading] = React.useState(false)
    const [logs, setLogs] = React.useState([]);
    const [cancelModal, setCancelModal] = React.useState(false);
    const [donotCover, setDonotCover] = React.useState(false);
    const [couldNotCover, setCouldNotCover] = React.useState(false);
    const [checkinCheckoutModal, setCheckinCheckoutModal] = React.useState(false);
    const [assignInterpreter, setAssignInterpreter] = React.useState(false);
    const [extraMileage, setExtraMileage] = React.useState(false);


    const callViewApi = async () => {
        const callBack = (success, message, data) => {
            setLoading(false);
            if (success) {
                setItem(data)
                console.log(data)
            }
            else {
                console.log(message)
            }
        }

        dispatch(fetchVendorAppointmentView(id, callBack))
    };

    const fetchLogs = async () => {
        const callBack = (success, message, data) => {
            if (success) {
                setLogs(data)
                console.log(data)
            }
            else {
                console.log(message)
            }
            // setLogs()
        }
        dispatch(fetchVendorAppointmentLogs(id, callBack))
    }

    React.useEffect(() => {
        setLoading(true)
        callViewApi();
        // fetchLogs();

    }, [id]);
    const handleCancel = () => {
        setCancelModal(true);
    };
    const handleCloseCancel = () => {
        setCancelModal(false);
    };
    const handleDonotCover = () => {
        setDonotCover(true);
    };
    const handleCloseDonotCover = () => {
        setDonotCover(false);
    };
    const handleCouldNotCover = () => {
        setCouldNotCover(true);
    };
    const handleCloseCouldNotCover = () => {
        setCouldNotCover(false);
    };
    const handleOpenCheckinCheckoutModal = () => {
        setCheckinCheckoutModal(true);
    };
    const handleCloseCheckinCheckoutModal = () => {
        setCheckinCheckoutModal(false);
    };
    const handleAssignInterpreter = () => {
        setAssignInterpreter(true);
    };
    const handleCloseAssignInterpreter = () => {
        setAssignInterpreter(false);
    };

    const handleExtraMileage = () => {
        setExtraMileage(true);
    };
    const handleCloseExtraMileage = () => {
        setExtraMileage(false);
    };

    const handleSubmit = (data, end_point, callBack) => {
        setLoading(true)
        const submitCallback = (success, message) => {
            callBack && callBack()
            if (success) {
                handleCloseCancel();
                handleCloseDonotCover();
                handleCloseCouldNotCover();
                handleCloseCheckinCheckoutModal();
                handleCloseAssignInterpreter();
                handleCloseExtraMileage();
                callViewApi();
                fetchLogs()
                toast.success(message, {
                    className: "successToast",
                });
                setLoading(false)
            }
            else {
                toast.error(message,
                    { className: "errorToast", }
                );
                setLoading(false)
            }
        }
        dispatch(
            setActionAssign(
                id,
                data,
                end_point,
                submitCallback
            )
        )
    }
    const mileageCheck = (val) => {
        return item?.appointment_details?.[val];
    }
    return (
        <div className="content" style={{}}>
            {loading && <FullPageLoader />}
            <div className="card_table view_table_custom">
                {(mileageCheck('extra_mileage') && mileageCheck('extra_mileage_request') == null) ?
                    <div className='softAlert waiting'>
                        <h3>We've received your request for extra mileage — awaiting admin approval.</h3>
                    </div>
                    :
                    (mileageCheck('extra_mileage') && mileageCheck('extra_mileage_request') == 1) ?
                        <div className='softAlert approved'>
                            <h3>The extra mileage request for this appointment have been approved.</h3>
                        </div>
                        : (mileageCheck('extra_mileage') && mileageCheck('extra_mileage_request') == 0) ?
                            <div className='softAlert rejected'>
                                <h3>The extra mileage request for this appointment have been rejected.</h3>
                            </div>
                            :
                            ''
                }
                <div className="row_main_head">
                    <h2 className={`main_heading`}>View Appointment # {item?.appid}</h2>
                    <div className='text-transform-capitalize main_heading' >
                        Status : {item?.status}
                    </div>
                </div>

                <div className='row-primary flex-wrap'>
                    {(item?.appointment_details?.extra_mileage_request == null && item?.status !== "completed") &&
                        <SubmitButton buttonType="button" className={'lightBlue'} btnText="Request extra mileage" handleSubmit={handleExtraMileage} />
                    }
                    {item?.status !== "completed" &&
                        <SubmitButton buttonType="button" className={'green'} btnText={item?.interpreter_id ? "Reassign" : "Assign"} handleSubmit={handleAssignInterpreter} />
                    }
                    {/* {(item?.status !== "CNC" && item?.status !== "cancelled" && item?.status !== "completed") && <SubmitButton buttonType="button" btnText="Could Not Cover" className="yellow" handleSubmit={handleCouldNotCover} />} */}
                    {(item?.status !== "cancelled" && item?.status == "assigned" && item?.status !== "completed") && <SubmitButton buttonType="button" className={'tomatoRed'} btnText="Cancel" handleSubmit={handleCancel} />}
                    {(item?.status !== "cancelled" && item?.status !== "completed") &&
                        <SubmitButton buttonType="button" className="Cancle_button"
                            btnText="Checkin / checkout"
                            data-bs-toggle="modal"
                            data-bs-target="#checkinCheckoutAdjustmentModal" handleSubmit={handleOpenCheckinCheckoutModal} />
                    }

                </div>

                <ViewTable item={item} />
            </div>

            <SelectInterpreterModal
                isVendorForm={true}
                isOpen={assignInterpreter}
                onClose={handleCloseAssignInterpreter}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
            />

            <CancelModal
                isOpen={cancelModal}
                onClose={handleCloseCancel}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
            />

            <ExtraMileage
                isOpen={extraMileage}
                onClose={handleCloseExtraMileage}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
            />
            <CheckinCheckoutAdjustmentModal
                isOpen={checkinCheckoutModal}
                handleClose={handleCloseCheckinCheckoutModal}
                onConfirm={handleSubmit}
                appointmentId={id}
                onSubmit={handleSubmit}
                item={item}
                loader={loading}
            />
        </div>
    )
}





export default AppointmentView